import { render, staticRenderFns } from "./terms-table.vue?vue&type=template&id=a7befaf4&"
import script from "./terms-table.vue?vue&type=script&lang=js&"
export * from "./terms-table.vue?vue&type=script&lang=js&"
import style0 from "./terms-table.vue?vue&type=style&index=0&id=a7befaf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports